import { combineReducers } from "redux";

import theme from "./theme";
import auth from "./auth";
import data from "./data";
import explorer from "./explorer";
import smartTemplate from "./smart_template";
import ticket from "./ticket";

export default combineReducers({
    theme,
    auth,
    data,
    explorer,
    smartTemplate,
    ticket,
});
